import { AxiosPromise } from 'axios';
import httpClient from './httpClient';
import API from '../constants/api';

export const dealersApi = {
  searchDealers(search: string): AxiosPromise<any> {
    return httpClient.get(API.DEALERS_PATH + '/?disable_search_key=true&search=' + encodeURIComponent(search));
  },
};
